import AccountTreeIcon from '@mui/icons-material/AccountTree'
import AssignmentIcon from '@mui/icons-material/Assignment'
import AttachFileIcon from '@mui/icons-material/AttachFile'
import DashboardIcon from '@mui/icons-material/Dashboard'
import InboxIcon from '@mui/icons-material/Inbox'
import NotificationsIcon from '@mui/icons-material/Notifications'
import TuneIcon from '@mui/icons-material/Tune'
import Divider from '@mui/material/Divider'
import List from '@mui/material/List'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import ListSubheader from '@mui/material/ListSubheader'

import { useAuthenticatedUser } from '../../auth/hooks/useAuthenticatedUser'
import { Link } from '../../router/components/Link'

interface Props {
  onItemClick: () => void
}

export const AansluitingMenu = ({ onItemClick }: Props) => {
  const {
    canViewDashboard,
    canViewProjecten,
    canViewCombiOpdrachten,
    canViewOpdrachten,
    canViewAssignedBijlagen,
    canViewActiviteiten,
  } = useAuthenticatedUser()

  const shouldRender =
    canViewDashboard ||
    canViewProjecten ||
    canViewCombiOpdrachten ||
    canViewOpdrachten ||
    canViewAssignedBijlagen ||
    canViewActiviteiten

  return shouldRender ? (
    <>
      <List subheader={<ListSubheader>Aansluiting</ListSubheader>}>
        {canViewDashboard && (
          <ListItemButton
            component={Link}
            onClick={onItemClick}
            to="/aansluiting/dashboard"
          >
            <ListItemIcon sx={{ color: 'black' }}>
              <DashboardIcon />
            </ListItemIcon>
            <ListItemText primary="Dashboard" />
          </ListItemButton>
        )}

        {canViewProjecten && (
          <ListItemButton
            component={Link}
            onClick={onItemClick}
            to="/aansluiting/projecten"
          >
            <ListItemIcon sx={{ color: 'black' }}>
              <InboxIcon />
            </ListItemIcon>
            <ListItemText primary="Projecten" />
          </ListItemButton>
        )}

        {canViewOpdrachten && (
          <ListItemButton
            component={Link}
            onClick={onItemClick}
            to="/opdrachten"
          >
            <ListItemIcon sx={{ color: 'black' }}>
              <AssignmentIcon />
            </ListItemIcon>
            <ListItemText primary="Opdrachten" />
          </ListItemButton>
        )}

        {canViewCombiOpdrachten && (
          <ListItemButton
            component={Link}
            onClick={onItemClick}
            to="/combiopdrachten"
          >
            <ListItemIcon sx={{ color: 'black' }}>
              <AssignmentIcon />
            </ListItemIcon>
            <ListItemText primary="Combi opdrachten" />
          </ListItemButton>
        )}

        {canViewActiviteiten && (
          <ListItemButton
            component={Link}
            onClick={onItemClick}
            to="/aansluiting/activiteiten"
          >
            <ListItemIcon sx={{ color: 'black' }}>
              <NotificationsIcon />
            </ListItemIcon>
            <ListItemText primary="Activiteiten" />
          </ListItemButton>
        )}

        {canViewAssignedBijlagen && (
          <ListItemButton
            component={Link}
            onClick={onItemClick}
            to="/aansluiting/bijlagen"
          >
            <ListItemIcon sx={{ color: 'black' }}>
              <AttachFileIcon />
            </ListItemIcon>
            <ListItemText primary="Bijlagen" />
          </ListItemButton>
        )}

        {canViewAssignedBijlagen && (
          <ListItemButton
            component={Link}
            onClick={onItemClick}
            to="/aansluiting/subprocessen"
          >
            <ListItemIcon sx={{ color: 'black' }}>
              <AccountTreeIcon />
            </ListItemIcon>
            <ListItemText primary="Subprocessen" />
          </ListItemButton>
        )}

        {canViewProjecten && (
          <ListItemButton
            component={Link}
            onClick={onItemClick}
            to="/aansluiting/contractinstellingen"
          >
            <ListItemIcon sx={{ color: 'black' }}>
              <TuneIcon />
            </ListItemIcon>
            <ListItemText primary="Contractinstellingen" />
          </ListItemButton>
        )}
      </List>

      <Divider />
    </>
  ) : null
}
